export default {
  pageTitle: '商务服务',
 heroDesc: '一站式跨境商务服务，助力企业全球化发展',
 featuresTitle: '服务特色',
 featuresSubtitle: '专业、高效、全面的商务服务',
 feature1Title: '全球网络',
 feature1Desc: '覆盖50+国家和地区的服务网络',
 feature2Title: '专业团队',
 feature2Desc: '经验丰富的专业服务团队',
 feature3Title: '一站式服务',
 feature3Desc: '从注册到运营的全流程服务',
 feature4Title: '高效便捷',
 feature4Desc: '快速响应，高效办理各项业务',
 purposeTitle: '服务目标',
 purposePara1: '国际商业解决方案的目的在于利用我们境外的法律、商业服务网络帮助客户解决跨境商务活动中可能出现的法律、商业中的运作困难。',
 purposePara2: '我们致力于降低企业运作成本，规避风险，尽量消除因政治、经济、人文因素引起的降低财产收益的风险，为企业的全球化发展保驾护航。',
 viewDetails: '查看详情',
 service1Title: '公司注册和管理',
 service1Subtitle: '全球商业组织设立与管理',
 service1Desc: '可以提供香港、澳门、新加坡、英属维尔京、萨摩亚、塞舌尔、英属安圭拉、巴哈马、巴拿马、开曼、百慕大、美国、菲律宾、马来西亚、缅甸等有限公司、合伙企业、分支机构等商业组织的设立和管理服务。',
 service1Feature1Title: '公司设立服务',
 service1Feature1Item1: '香港、澳门、新加坡公司设立',
 service1Feature1Item2: '英属维尔京、萨摩亚、塞舌尔公司设立',
 service1Feature1Item3: '开曼、百慕大、巴哈马、巴拿马公司设立',
 service1Feature1Item4: '美国各州公司设立',
 service1Feature1Item5: '菲律宾、马来西亚、缅甸等东南亚公司设立',
 service1Feature1Item6: '有限公司、合伙企业、分支机构设立',
 service1Feature2Title: '公司管理服务',
 service1Feature2Item1: '公司架构和内部治理优化方案',
 service1Feature2Item2: '组织架构所有权链绘制、管理和更新',
 service1Feature2Item3: '公司各种文件、签字办理',
 service1Feature2Item4: '公司变更、备案手续',
 service1Feature2Item5: '公司解散清盘服务',
 service1Feature2Item6: '股权质押等一系列手续',
 service2Title: '银行账户',
 service2Subtitle: '全球银行开户与金融服务',
 service2Desc: '通过与全球多家大型知名商业银行、私人银行的合作，为客户提供开立账户前的预约、商业计划书草拟、文件核证及陪同面签等服务，为企业资金融通、规避外汇风险、选择金融工具提供咨询意见。',
 service2Feature1Title: '银行开户服务',
 service2Feature1Item1: '开立账户前的预约服务',
 service2Feature1Item2: '商业计划书草拟',
 service2Feature1Item3: '文件核证及陪同面签',
 service2Feature1Item4: '大陆银行开户服务',
 service2Feature1Item5: '香港主流银行开户',
 service2Feature1Item6: '新加坡银行开户',
 service2Feature1Item7: '美国银行开户',
 service2Feature1Item8: '菲律宾、马来西亚、缅甸银行开户',
 service2Feature2Title: '金融咨询服务',
 service2Feature2Item1: '企业资金融通咨询',
 service2Feature2Item2: '规避外汇风险方案',
 service2Feature2Item3: '金融工具选择咨询',
 service2Feature2Item4: '跨境资金管理',
 service2Feature2Item5: '私人银行服务对接',
 service2Feature2Item6: '商业银行服务安排',
 service3Title: '会计审计',
 service3Subtitle: '专业的财税审计服务',
 service3Desc: '依靠自身海外审计团队及合作机构为客户提供会计、审计及报税服务，帮助客户提出税务反对意见、优化跨境财务管理方式、规避财税风险、根据会计准则差异提供咨询意见及培训。',
 service3Feature1Title: '会计审计服务',
 service3Feature1Item1: '专业会计服务',
 service3Feature1Item2: '年度审计服务',
 service3Feature1Item3: '报税服务',
 service3Feature1Item4: '合规性审查',
 service3Feature1Item5: '财务报表编制',
 service3Feature2Title: '财税咨询服务',
 service3Feature2Item1: '税务反对意见提出',
 service3Feature2Item2: '优化跨境财务管理方式',
 service3Feature2Item3: '规避财税风险',
 service3Feature2Item4: '会计准则差异咨询',
 service3Feature2Item5: '财税培训服务',
 service4Title: '公司查册',
 service4Subtitle: '公司信息查询与文件查证',
 service4Desc: '提供公司存续和合法性查册以及法律文件查证服务，可对当地公司进行全面查询。',
 service4Feature1Title: '公司基本信息查询',
 service4Feature1Item1: '公司成立日期',
 service4Feature1Item2: '注册证书编号',
 service4Feature1Item3: '董事和股东姓名、地址',
 service4Feature1Item4: '公司法定秘书及其地址',
 service4Feature1Item5: '公司注册地址',
 service4Feature1Item6: '公司注册资本',
 service4Feature2Title: '公司文件查证',
 service4Feature2Item1: '香港公司章程复印件',
 service4Feature2Item2: '香港公司周年申报表',
 service4Feature2Item3: '公司信誉良好证书',
 service4Feature2Item4: '注册代理人证书',
 service4Feature2Item5: '其他相关法律文件',
 service5Title: '跨境投资',
 service5Subtitle: '全方位跨境投资服务',
 service5Desc: '跨境投资服务不但包含境外法律服务，还包含提供投资战略方案、全面尽职调查、银行服务和融资方案、税收计划、跨境并购架构搭建等。',
 service5Feature1Title: '投资策略与尽调',
 service5Feature1Item1: '投资战略方案制定',
 service5Feature1Item2: '法律尽职调查',
 service5Feature1Item3: '政策尽职调查',
 service5Feature1Item4: '财务尽职调查',
 service5Feature1Item5: '税务尽职调查',
 service5Feature1Item6: '劳工、宗教、物流调查',
 service5Feature2Title: '投资实施服务',
 service5Feature2Item1: '银行服务和融资方案',
 service5Feature2Item2: '税收计划',
 service5Feature2Item3: '跨境并购架构搭建',
 service5Feature2Item4: '融资结构安排',
 service5Feature2Item5: '自贸区使用方案',
 service5Feature2Item6: '商务考察、旅行安排',
 service6Title: '国际税务计划、境外税务反对',
 service6Subtitle: '专业税务规划与反对服务',
 service6Desc: '企业在境外投资发展的过程中，必须要对投资及贸易国的税务政策有更多的了解。LEVIY为客户提供最完善的税收政策分析，帮助企业在跨国经营中更合理地调配全球各地分公司及子公司之间的资本及利润分配。',
 service6Feature1Title: '国际税务计划',
 service6Feature1Item1: '投资及贸易国税务政策分析',
 service6Feature1Item2: '全球分公司资本调配方案',
 service6Feature1Item3: '利润分配优化',
 service6Feature1Item4: '降低企业成本方案',
 service6Feature1Item5: '利润留存和增值规划',
 service6Feature2Title: '境外税务反对',
 service6Feature2Item1: '不合理税收识别',
 service6Feature2Item2: '安排专业律师、税务师',
 service6Feature2Item3: '提出税务反对',
 service6Feature2Item4: '追回相应税款',
 service6Feature2Item5: '税务争议解决',
 service7Title: '国际商业解决方案',
 service7Subtitle: '一揽子商业解决方案',
 service7Desc: '根据客户在境外投资和服务的需要为客户制定一揽子商业解决方案，包括投资贸易目的地法律查明、人文和当地社会文化查明、政府作业方式查明、企业战略规划、品牌规划、税务规划及财产规划。',
 service7Feature1Title: '前期调研与规划',
 service7Feature1Item1: '投资贸易目的地法律查明',
 service7Feature1Item2: '人文和当地社会文化查明',
 service7Feature1Item3: '政府作业方式查明',
 service7Feature1Item4: '企业战略规划',
 service7Feature1Item5: '品牌规划',
 service7Feature1Item6: '税务规划及财产规划',
 service7Feature2Title: '风险规避与保障',
 service7Feature2Item1: '企业风险规避规划',
 service7Feature2Item2: '股东、董事收益风险规划',
 service7Feature2Item3: '公司收益风险战略规划',
 service7Feature2Item4: '保险服务安排',
 service7Feature2Item5: '私人银行服务',
 service7Feature2Item6: '商业银行服务',
}
